import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Logo from './logo.svg';

const StyledHeader = styled.header`
  display: grid;
  grid-template-columns: 0.5rem 1fr 0.5rem;
  padding: 0.5rem 0;
  color: white;
  background-color: ${t => t.theme.blue};

  .Logo {
    width: 100%;
    max-width: 20rem;
    height: auto;
  }

  a,
  ul {
    grid-column: 2/3;
  }
  
  ul {
    grid-row: 2/3;
    display: flex;
    justify-content: flex-start;
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      padding: 1rem;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
    text-align: center;
  }

  @media (min-width: ${t => t.theme.desktopBreakpoint}) {
    grid-template-columns: 1fr repeat(12, 100px) 1fr;

    a {
      grid-column: 2/5;
      grid-row: 1/2;
      text-align: left;
    }

    ul {
      grid-column: 6/14;
      grid-row: 1/2;
      justify-content: flex-end;
      align-items: flex-end;
    }
  }
`;

function Header() {
  return (
    <StyledHeader>
      <Link to="/">
        <img src={Logo} alt="Logo" className="Logo" />
      </Link>
      <ul>
        <li>
          <NavLink to="/" activeClassName="active" exact>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/locations" activeClassName="active" exact>
            Locations
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" activeClassName="active" exact>
            About
          </NavLink>
        </li>
      </ul>
    </StyledHeader>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx